<template>
    <div class="mt-4">
        <div v-if="store.categoriesInScope.length === 0" class="notification is-info has-no-glow-effect">
            <p class="has-text-centered">{{ translate("admin_schedules_list.delete.empty_scope_info") }}</p>
        </div>
        <template v-else>
            <div class="is-flex is-justify-content-space-between is-align-items-center mb-2">
                <p class="is-size-7 is-uppercase has-text-grey-light has-text-weight-bold">
                    {{ translate("admin_schedules_list.delete.affected_categories_label") }}
                </p>
                <p class="is-size-7 has-text-grey-light">
                    {{ translate("admin_schedules_list.delete.total_fights_label", false, [store.totalFightsInScope]) }}
                </p>
            </div>

            <SelectionList :options="store.categoriesInScope" readonly>
                <template v-slot:option="{ option: category }">
                    <div class="is-flex is-justify-content-space-between is-align-items-center is-flex-grow-1 py-2">
                        <div>
                            <p class="has-text-white has-text-weight-semibold">{{ category.name }}</p>
                            <p class="is-size-7 has-text-grey-light">
                                {{ translate("admin_schedules_list.delete.fights_in_scope", false, [category.totalFights]) }}
                            </p>
                        </div>
                        <div class="tags mb-0">
                            <span v-if="category.hasFinishedFights" class="tag is-danger">
                                {{ translate("admin_schedules_list.delete.status_finished") }}
                            </span>
                            <span v-if="category.isDivided" class="tag" :class="store.dividedBlocksInScope ? 'is-danger' : 'is-info'">
                                {{
                                    translate(
                                        store.dividedBlocksInScope
                                            ? "admin_schedules_list.delete.status_divided"
                                            : "admin_schedules_list.delete.status_spans_schedules",
                                    )
                                }}
                            </span>
                            <span v-if="!category.hasFinishedFights && !category.isDivided" class="tag is-success">
                                {{ translate("admin_schedules_list.delete.status_ready") }}
                            </span>
                        </div>
                    </div>
                </template>
            </SelectionList>

            <div v-if="!store.canDeleteScope" class="notification is-danger has-no-glow-effect mt-3">
                <p>
                    <span class="icon has-text-danger">
                        <i class="fas fa-times-circle"></i>
                    </span>
                    {{ bannerHeadline }}
                </p>
            </div>
        </template>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { translate } from "../../Common/translations";
    import SelectionList from "../../Common/SelectionList.vue";
    import { useDeletingFightsStore } from "./useDeletingFightsStore";

    const store = useDeletingFightsStore();

    const bannerHeadline = computed(() => {
        const reasons: string[] = [];
        if (store.finishedCategoriesCount > 0) {
            reasons.push(translate("admin_schedules_list.delete.banner_reason_finished"));
        }
        if (store.dividedCategoriesCount > 0 && store.dividedBlocksInScope) {
            reasons.push(translate("admin_schedules_list.delete.banner_reason_divided"));
        }
        return `${translate("admin_schedules_list.delete.banner_headline_prefix")} ${reasons.join(
            ` ${translate("admin_schedules_list.delete.banner_reason_joiner")} `,
        )}`;
    });
</script>
